import React, { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TotalsFragment } from '../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import parseCurrency from '../../utils/parseCurrency';
import Fragment from './Totals.gql';
import TotalsSkeleton from './TotalsSkeleton';

import styles from './FirstToDonateTotals.scss';

const FRAGMENT = buildQuery(Fragment);

export const FirstToDonateTotals: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { loading, error, refetch, data = null } = usePageQuery<TotalsFragment>(
    FRAGMENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  if (loading) return <TotalsSkeleton animated displayRefreshButton={false} />;

  if (error && !data?.targetWithCurrency?.value) {
    return <TotalsSkeleton onRefresh={refetch} />;
  }

  if (!data) return null;

  const { targetWithCurrency, owner } = data;

  const targetCurrency = targetWithCurrency?.currencyCode ?? 'GBP';
  const title = owner?.name ?? '';
  const targetValue = targetWithCurrency?.value ?? 0;
  const target = parseCurrency(targetCurrency, targetValue / 100, {
    roundDown: true,
    wholeNumber: true,
  });

  return (
    <div data-qa="first-to-donate-totaliser-message">
      <h3>{t('page.totals.firstToDonate.heading')}</h3>
      <span className={styles.copy}>
        <Trans i18nKey="page.totals.firstToDonate.description">
          Help{' '}
          <span className={styles.bold}>
            {{
              title,
            }}
          </span>{' '}
          reach the{' '}
          <span className={styles.branded}>
            {{
              target,
            }}
          </span>{' '}
          target
        </Trans>
      </span>
    </div>
  );
};
